import { Business } from 'model';
import styles from './BusinessDetails.module.css';
import { IonRouterLink } from '@ionic/react';
import { IconLink, IconLocation, IconPhone, IconTime } from './QuirkIcons/index.js';
import { HoursOfOperation } from './HoursOfOperation.js';
import { phoneurl, weburl } from '../util/url.js';
import { mapurl } from '../util/mapurl.js';

export interface BusinessDetailsProps {
	business: Business;
}

export function BusinessDetails({ business }: BusinessDetailsProps) {
	return (
		<>
			<div className={styles.businessContacts}>
				{business?.address && business?.address !== '' && (
					<IonRouterLink target="_blank" href={mapurl(business?.address + ' ' + business?.city)}>
						<div className={styles.iconBullet}>
							<IconLocation />

							<div className={styles.servicesText} data-testid="businessAddress">
								{business?.address}
							</div>
						</div>
					</IonRouterLink>
				)}
				{business?.website && business?.website !== '' && (
					<IonRouterLink target="_blank" href={weburl(business?.website)}>
						<div className={styles.iconBullet}>
							<IconLink />
							<div className={styles.servicesText}>{business?.website}</div>
						</div>
					</IonRouterLink>
				)}
				{business?.phone && business?.phone !== '' && (
					<IonRouterLink target="_blank" href={phoneurl(business?.phone)}>
						<div className={styles.iconBullet}>
							<IconPhone />
							<div className={styles.servicesText} data-testid="businessPhone">
								{business?.phone}
							</div>
						</div>
					</IonRouterLink>
				)}
				{business?.hours && business?.website && (
					<IonRouterLink target="_blank" href={weburl(`${business?.website}#hours`)}>
						<HoursOfOperation hours={business?.hours} icon={<IconTime />} />
					</IonRouterLink>
				)}
				{business?.hours && !business?.website && (
					<HoursOfOperation hours={business?.hours} icon={<IconTime />} />
				)}
			</div>
			<hr />
			<div className={styles.servicesContainer}>
				{business?.items?.length ? (
					<div>
						<h5>Items For Sale or Services</h5>
						<div className={styles.servicesSpans}>
							{business?.items?.map(({ name }) => (
								<span key={name} className="pill">
									{name}
								</span>
							))}
						</div>
					</div>
				) : null}
			</div>
		</>
	);
}
